import { render, staticRenderFns } from "./WorksItem.vue?vue&type=template&id=9e8e8bfe&scoped=true&"
import script from "./WorksItem.vue?vue&type=script&lang=js&"
export * from "./WorksItem.vue?vue&type=script&lang=js&"
import style0 from "./WorksItem.vue?vue&type=style&index=0&id=9e8e8bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8e8bfe",
  null
  
)

export default component.exports